<!-- Loader.vue -->
<template>
    <div>
      <div class="d-flex justify-content-center spinner-container">
        <div class="spinner"></div>
      </div>
      <div class="text-center mt-3 ">Loading
        <span
            v-for="(dot, index) in dots"
            :key="index"
            class="loader__dot"
            :style="{ animationDelay: `${index * 0.2}s` }">.</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'SpinnersLoader',
    data () {
      return {
        dots: Array(4).fill('.')
      }
    }
  }
  </script>
  
  <style scoped>
  .spinner-container {
    margin-top: 215px;
  }
  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid #30b5f2;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes blink {50% { color: transparent }}
  .loader__dot { animation: 1s blink infinite }
  .loader__dot:nth-child(2) { animation-delay: 250ms }
  .loader__dot:nth-child(3) { animation-delay: 500ms }
  </style>